import React, { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useAuth } from '../../context/AuthContext';
import { emailService } from '../../services/emailService';

/** Send a test through whichever mailbox school emails go from now. */
const TestEmailDialog: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [to, setTo] = useState(user?.email ?? '');
  const [sending, setSending] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);

  const send = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!to.trim() || sending) return;
    setSending(true);
    setProblem(null);
    try {
      const r = await emailService.sendTest(to.trim());
      enqueueSnackbar(`Test sent to ${r.to} from ${r.sender === 'own' ? 'your mailbox' : 'EduBook mail'}`, { variant: 'success' });
      onClose();
    } catch (err: any) {
      setProblem(err?.message || 'The test email couldn’t be sent');
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open onClose={() => !sending && onClose()} maxWidth="xs" fullWidth>
      <form onSubmit={send} noValidate>
        <DialogTitle component="div" sx={{ pb: 1 }}>
          <Typography variant="h6" fontWeight={700}>Send a test email</Typography>
          <Typography variant="caption" color="text.secondary">It goes out exactly the way family emails do.</Typography>
        </DialogTitle>
        <DialogContent>
          <TextField label="Send to" type="email" value={to} onChange={e => setTo(e.target.value)} fullWidth sx={{ mt: 1 }} />
          {problem && <Alert severity="error" sx={{ mt: 2, borderRadius: '10px' }}>{problem}</Alert>}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={onClose} color="inherit" disabled={sending}>Cancel</Button>
          <Button type="submit" variant="contained" disableElevation disabled={!to.trim() || sending}>
            {sending ? 'Sending…' : 'Send test'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default TestEmailDialog;
